module.exports = __webpack_public_path__ + "static/media/zoleLose_10000_25000.d7c5f097.png";